import ModalContext, { IModalContext, ModalConfig } from "@/contexts/ModalsContext";
import { useCallback, useState } from "react";

const filterOut = (name: string) => (list: ModalConfig[]) => list.filter((item) => item.modalName !== name);

const ModalContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [list, setList] = useState<ModalConfig[]>([]);
  const showModal = useCallback((props: ModalConfig) => {
    setList((old) => {
      const newItems = filterOut(props.modalName)(old);
      if (props.onModalOpen) {
        setTimeout(props.onModalOpen, 0);
      }
      return [props, ...newItems];
    });
  }, []);

  const closeModal = useCallback(() => {
    setList((old) => {
      const newItems = [...old];
      newItems.pop();
      return newItems;
    });
  }, []);

  const closeModalByName = (name: string) => setList((items) => items.filter(({ modalName }) => modalName !== name));

  const value: IModalContext = {
    list,
    showModal,
    closeModal,
    closeModalByName,
  };

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
};

export default ModalContextProvider;
